import type { UserAuthData } from '@/lib/auth/permissions.types'
import type { BillingPlan } from '@/lib/billing/types'

// Store contract without the database client, which throws at import without env.

export interface PlanActor {
  userId: string
  /** Name, else email, at the time of the change. */
  name: string | null
}

export type PlanOperation = 'create' | 'update' | 'archive' | 'restore'

export interface PlanWrite {
  before: BillingPlan
  plan: BillingPlan
}

/** A refusal the routes return with its status. */
export class PlanWriteError extends Error {
  constructor(message: string, readonly status: 400 | 404 | 409) {
    super(message)
  }
}

export class PlanConflictError extends Error {
  constructor(readonly changedAt: string | null, readonly changedBy: string | null, readonly plan: BillingPlan) {
    super('This plan was changed after you opened it.')
  }
}

export function planActor(user: Pick<UserAuthData, 'user_id' | 'name' | 'email'>): PlanActor {
  return { userId: user.user_id, name: user.name?.trim() || user.email || null }
}
